import React from 'react'
import { Link } from 'react-router-dom'
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap'
import withAppdata from '../AppConfig/withAppdata'
import VenuemanagerPersonalPreferencesDialog from '../Dialogs/VenuemanagerPersonalPreferencesDialog'

// Initials from the email's local part: 'anssi.lindqvist@...' -> 'AL', 'jari@...' -> 'J'.
// displayName is the VENUE's name, not the user's, so it is no use for a personal avatar.
export const initialsFor = (email) => {
  const local = String(email || '').split('@')[0]
  const parts = local.split(/[._-]+/).filter(Boolean)
  if (parts.length === 0) return '?'
  return parts
    .slice(0, 2)
    .map((p) => p[0].toUpperCase())
    .join('')
}

// Sidebar footer account card: who is signed in, at which venue. Opens upwards with
// Omat asetukset (the same dialog as the navbar button) and Kirjaudu ulos.
function SidebarAccount({ appdata, email, displayName, logoutPath }) {
  const [menuOpen, setMenuOpen] = React.useState(false)
  const [preferencesOpen, setPreferencesOpen] = React.useState(false)

  return (
    <>
      <VenuemanagerPersonalPreferencesDialog
        appdata={appdata}
        isOpen={preferencesOpen}
        toggle={() => setPreferencesOpen(!preferencesOpen)}
      />
      <Dropdown isOpen={menuOpen} toggle={() => setMenuOpen(!menuOpen)} direction='up' className='sidebar-account'>
        <DropdownToggle tag='button' type='button' className='sidebar-account-card' title={email}>
          <span className='sidebar-account-avatar'>{initialsFor(email)}</span>
          <span className='sidebar-account-text'>
            <span className='sidebar-account-email'>{email}</span>
            <span className='sidebar-account-venue'>{displayName}</span>
          </span>
          <span className='material-symbols-rounded sidebar-account-more'>unfold_more</span>
        </DropdownToggle>
        <DropdownMenu className='sidebar-account-menu'>
          <DropdownItem onClick={() => setPreferencesOpen(true)}>Omat asetukset</DropdownItem>
          <DropdownItem tag={Link} to={logoutPath}>
            Kirjaudu ulos
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </>
  )
}

export default withAppdata(SidebarAccount)
